import React from "react"
import { useTranslation } from "react-i18next"
import { Radio } from "ui/Radio"
import { PRICING_TYPES } from "../../utils/constants"
import { Form, Tooltip } from "antd"
import PropTypes from "prop-types"

export const PricingTypeSelector = ({ value, setPricingType, form, setIsShowErrorMessage, onPriceInteraction, isFlatRateDisabled }) => {
  const [t] = useTranslation()
  const onChangeHandler = (e) => {
    setIsShowErrorMessage(false)
    const pricingType = e.target.value
    form.setFieldValue("pricing_type", pricingType)
    setPricingType(pricingType)
    onPriceInteraction?.()
  }
  return (
    <div>
      <Form.Item name="pricing_type" className="mb-0"></Form.Item>
      <div className="flex flex-wrap gap-3">
        <Radio checked={value === PRICING_TYPES.PER_PERSON} onChange={onChangeHandler} value={PRICING_TYPES.PER_PERSON}>
          {t("trip.pricing_types.charge_per_person")}
        </Radio>
        <Tooltip title={isFlatRateDisabled ? t("trip.pricing_types.flat_rate_disabled_tooltip") : undefined}>
          <Radio checked={value === PRICING_TYPES.FLAT_RATE} onChange={onChangeHandler} value={PRICING_TYPES.FLAT_RATE} disabled={isFlatRateDisabled}>
            {t("trip.pricing_types.charge_flat_rate")}
          </Radio>
        </Tooltip>
      </div>
    </div>
  )
}
PricingTypeSelector.propTypes = {
  value: PropTypes.string.isRequired,
  setPricingType: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  setIsShowErrorMessage: PropTypes.func.isRequired,
  onPriceInteraction: PropTypes.func,
  isFlatRateDisabled: PropTypes.bool,
};
